/**
 * Снимок демо-квартиры для кнопки «Демо». Обновляется JSON из DEV Menu:
 * соберите план в редакторе, скопируйте его и целиком замените `sample.json`.
 */
import { withDefaultLayers, type PlanLayers } from "@/shared/plan";
import sampleLayersData from "./sample.json";

// Снимок мог быть снят до появления нового слоя — дополняем, как старый файл
const sampleData = withDefaultLayers(sampleLayersData as unknown as Partial<PlanLayers>);

/** Возвращает независимую копию слоёв, чтобы демо можно было свободно редактировать. */
export const sampleLayers = (): PlanLayers => structuredClone(sampleData);
